// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-setting-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1rem;
}
.account-setting-container .info-container {
  height: 3.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  margin: 0px;
  margin-bottom: 1rem;
}
.account-setting-container .margin-top {
  margin-top: 1rem;
}
.account-setting-container .show-on-top {
  order: -1;
}
.account-setting-container .avatar-info-container {
  display: flex;
}
.account-setting-container .name-email-container {
  display: flex;
  flex-direction: column;
}
.account-setting-container .name-email-container .name {
  font-size: 0.875rem;
  line-height: 1.5rem;
  letter-spacing: 0.0094rem;
  color: var(--text-primary);
}
.account-setting-container .name-email-container .email {
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.0156rem;
  color: var(--text-secondary);
}
.account-setting-container .icons-container {
  display: flex;
}
.account-setting-container .new-badge {
  --background: var(--color-accent);
  --color: var(--surface-primary);
  border-radius: 0.25rem;
  margin-right: 1rem;
  font-weight: bold;
  font-size: 0.8125rem;
  --padding-start: 0.3438rem;
  --padding-end: 0.3438rem;
  line-height: 1.125rem;
  display: none;
}
.account-setting-container .check-icon {
  font-size: 24px;
  color: var(--color-accent);
}
@media (max-width: 576px) {
  .account-setting-container {
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-settings/account-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;AACJ;AACI;EACI,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,SAAA;AADR;AAII;EACI,aAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;AAHR;AAKQ;EACI,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;AAHZ;AAMQ;EACI,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;AAJZ;AAQI;EACI,aAAA;AANR;AASI;EACI,iCAAA;EACA,+BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;AAPR;AAUI;EACI,eAAA;EACA,0BAAA;AARR;AAWI;EArEJ;IAsEQ,eAAA;EARN;AACF","sourcesContent":[".account-setting-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 1rem;\n\n    .info-container {\n        height: 3.5rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0px;\n        margin: 0px;\n        margin-bottom: 1rem;\n    }\n\n    .margin-top {\n        margin-top: 1rem;\n    }\n\n    .show-on-top {\n        order: -1;\n    }\n\n    .avatar-info-container {\n        display: flex;\n    }\n\n    .name-email-container {\n        display: flex;\n        flex-direction: column;\n\n        .name {\n            font-size: 0.875rem;\n            line-height: 1.5rem;\n            letter-spacing: 0.0094rem;\n            color: var(--text-primary);\n        }\n\n        .email {\n            font-size: 0.8125rem;\n            line-height: 1.25rem;\n            letter-spacing: 0.0156rem;\n            color: var(--text-secondary);\n        }\n    }\n\n    .icons-container {\n        display: flex;\n    }\n\n    .new-badge {\n        --background: var(--color-accent);\n        --color: var(--surface-primary);\n        border-radius: 0.25rem;\n        margin-right: 1rem;\n        font-weight: bold;\n        font-size: 0.8125rem;\n        --padding-start: 0.3438rem;\n        --padding-end: 0.3438rem;\n        line-height: 1.125rem;\n        display: none;\n    }\n\n    .check-icon {\n        font-size: 24px;\n        color: var(--color-accent);\n    }\n\n    @media(max-width: 576px) {\n        padding: 0.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
